export default __webpack_public_path__ + "static/media/ketoicecream-wide@2x.b51bff2f.jpg";